import { useSyncExternalStore } from 'react';
import AuthService from '../services/auth.service';

const authService = AuthService.getInstance();

/**
 * React-reactive access to the current access token.
 *
 * Useful as an `enabled` gate for `useQuery` hooks that must wait for
 * auth to arrive before firing — without it, FormatLocaleProvider and
 * other top-of-tree providers fire queries before Embed.tsx has
 * exchanged the code, producing spurious 401s on every embed load.
 *
 * Consumers re-render automatically when callers invoke
 * `authService.notifyAuthChanged()` (typically from the embed / OIDC
 * handoff paths after hydrating the singleton).
 */
export function useAuthToken(): string | null {
  return useSyncExternalStore(
    (cb) => authService.subscribe(cb),
    () => authService.getAuthTokenSnapshot(),
    () => authService.getAuthTokenSnapshot(),
  );
}
